/* eslint-disable */
import React, { useState} from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import ToastNotification from "../../components/ToastNotification";
import BossDialog from "../../components/BossDialog";
import { EditPageHeader } from "../../components/EditPageHeader";

const BarcodesEditForm = (props) => {
  const lang = useTranslation();

    const blankDataItem = {
        ...props?.item,
        Barcode: props?.item?.copy ? "Copy of " + props?.item?.Barcode : props?.item?.Barcode ?? "",
        Title: props?.item?.Title,
        Archive: props?.item?.Archive ?? false
    }

    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {
        if (dataItem.Barcode == undefined || dataItem.Barcode == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_barcode_error_message });
            return false;
        }
        if (dataItem.Title == undefined || dataItem.Title == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Barcode: dataItem?.Barcode,
            Title: dataItem?.Title,
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["Barcode", "=", dataItem.Barcode]]

        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.Barcodes, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.BARCODES, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.Barcodes);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <BossDialog
                title={props.item.Barcode ?? lang.barcode_dialog_header}
                onClose={props.cancelEdit}
                width={"600px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <label>{lang.barcode_label} *</label>
                                <input
                                    name="Barcode"
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.Barcode}
                                />
                            </div>
                             <div className='col-6'>
                                <label>{lang.title_label} *</label>
                                <input
                                    name="Title"
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.Title}
                                />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <input style={{ border: "1px solid grey", marginTop: "26px" }} name={"Archive"} type='checkbox' onChange={onChange}/>
                                <label className="ml-2">{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog >
        </>
    )
}

export default BarcodesEditForm;